import Vue from 'vue'
import VueRouter from 'vue-router'
const Home = ()=>import('../components/home/Home')
const About = ()=>import('@/components/about/About')
const Contact = ()=>import('@/components/contact/Contact')
const Product = ()=>import('@/components/product/Product')
const Project = ()=>import('@/components/project/Project')
const Detail = ()=>import('@/components/detail/Detail')
const ProjectDetail = ()=>import('@/components/detail/ProjectDetail')
const MobileHome = () => import('@/views/mobile/Home')
const MobileAbout = () => import('@/views/mobile/About')
const MobileContact = () => import('@/views/mobile/Contact')
const MobileProduct = () => import('@/views/mobile/Product')
const MobileProductDetail = () => import('@/views/mobile/ProductDetail')
const MobileProject = () => import('@/views/mobile/Project')
const MobileProjectDetail = () => import('@/views/mobile/ProjectDetail')
Vue.use(VueRouter)

const routes = [
  {
    path: '',
    redirect:'/home'
  },
  {
    path: '/home',
    component:Home
  },
  {
    path: '/about',
    component:About
  },
  {
    path: '/contact',
    component:Contact
  },
  {
    path: '/product',
    component:Product,
  },
  {
    path: '/project',
    component:Project
  },
  {
    path: '/detail',
    component:Detail
  },
  {
    path: '/projectDetail',
    component:ProjectDetail
  },
  {
    path: '/mb_home',
    component:MobileHome
  },
  {
    path: '/mb_about',
    component:MobileAbout
  },
  {
    path: '/mb_contact',
    component:MobileContact
  },
  {
    path: '/mb_product',
    component:MobileProduct
  },
  {
    path: '/mb_productDetail',
    component:MobileProductDetail
  },
  {
    path: '/mb_project',
    component:MobileProject
  },
  {
    path: '/mb_projectDetail',
    component:MobileProjectDetail
  },
]

const router = new VueRouter({
  routes,
});

export default router
